<template>
  <div v-if="!$store.state.loading">
    <template v-if="hasProperty">
      <section
        class="
          flex flex-col
          text-center
          w-full
          md:w-3/5
          container-lg
          mx-auto
          px-4
          md:px-0
        "
      >
        <img
          alt="logo"
          class="w-full mb-4"
          src="https://photo-public.s3.amazonaws.com/suf/home/cuadros.png"
        />

        <template v-if="sale.Status.Payment == 'Approved'">
          <h3 class="text-2xl font-bold">{{ $t("success_payment.successful_purchase") }}</h3>
          <h4 class="text-lg mb-8">{{ $t("success_payment.successful_purchase_detail") }}</h4>
        </template>
        <template v-else-if="sale.Status.Payment == 'InProcess'">
          <h3 class="text-2xl font-bold">{{ $t("success_payment.payment_in_process") }}</h3>
          <h4 class="text-lg mb-8">{{ $t("success_payment.payment_in_process_detail") }}</h4>
        </template>
        <template v-else>
          <h3 class="text-2xl font-bold">{{ $t("success_payment.payment_was_declined") }}</h3>
          <h4 class="text-lg mb-8">
            {{ $t("success_payment.payment_was_declined_detail") }}
          </h4>
        </template>

        <p class="mb-4 text-grey" v-if="sale.Status.Payment == 'InProcess'">
          {{ $t("success_payment.payment_process_voucher_to") }}
          <span class="font-semibold" v-if="sale.Traveler">{{
            sale.Traveler.Contac.Email
          }}</span>
        </p>
        <p class="mb-4 text-grey" v-else>
          {{ $t("success_payment.payment_process_voucher_to") }}
          <span class="font-semibold" v-if="sale.Traveler">{{
            sale.Traveler.Contac.Email
          }}</span>
        </p>
        <!-- ToDo - solang -->
        <p class="w-full md:w-3/5 mx-auto text-grey">
          {{ $t("success_payment.payment_process_voucher_to_detail") }}
        </p>
      </section>

      <section class="w-full md:w-3/5 mx-auto container-lg px-4 md:px-0">
        <div class="flex flex-wrap md:px-12 mt-8">
          <div class="flex-auto flex-col w-3/5 md:w-auto">
            <div class="font-semibold">{{ $t("success_payment.date_of_purchase") }}</div>
            <div>{{ dateString(sale.SaleDate) }}</div>
          </div>
          <div class="flex-auto border-l"></div>
          <div class="flex-auto flex-col">
            <div class="font-semibold">Ticket</div>
            <div>{{ sale.ReservationNumber }}</div>
          </div>
          <div class="flex-auto border-l hidden md:inline-block"></div>
          <div
            class="
              flex-auto flex
              md:flex-col
              w-full
              md:w-auto
              border-y
              md:border-y-0
              py-4
              my-4
              md:my-0 md:py-0
            "
          >
            <div class="pr-2 md:pr-0 font-semibold">
              {{ $t("success_payment.banking_transaction") }}
            </div>
            <div>{{ sale.SaleId }}</div>
          </div>
        </div>

        <div
          class="
            w-full
            md:w-3/5
            mx-auto
            container-lg
            px-4
            md:px-0
            mt-10
            text-center
          "
          v-if="sale.Status.Payment == 'InProcess'"
        >
          <router-link
            class="
              backTo
              cursor-pointer
              bg-green-xcaret
              text-white
              rounded
              p-2
              pl-4
              pr-4
              cursor-pointer
            "
            :to="{
              name: 'albumes',
            }"
          >
            <span class="pointer-events-none">
              <span class="material-icons"> arrow_back </span>
              {{ $t("gallery.back_to_albums") }}
            </span>
          </router-link>
        </div>

        <div
          class="
            flex flex-col
            md:flex-row
            border-y-0
            md:border-y md:py-4 md:my-4 md:px-12
            items-center
          "
          v-if="downloadCode != null"
        >
          <template v-if="!isEvent">
            <div class="flex-auto font-semibold mb-4 md:mb-0">
              {{ $t("success_payment.code_to_download_your_photos") }}
              <strong class="text-sm text-black">
                {{ downloadCode }}
              </strong>
            </div>
            <a
              @click.stop="getAlbumsByEmail()"
              class="
                shadownBottom
                flex
                w-full
                md:w-auto
                justify-center
                items-center
                rounded-full
                py-2
                px-4
                bg-yellow-photo
                text-black
                cursor-pointer
              "
              v-if="!$store.state.isGuest"
            >
              {{ $t("messages.my_albumes") }}
            </a>
          </template>
          <template v-else>
            <div style="position: relative;text-align: center;width: 100%;display: ruby;">
            <a 
              class="
                shadownBottom
                flex
                self-start
                items-center
                rounded-full
                py-2
                px-4
                bg-yellow-photo
                text-black
                cursor-pointer"
              href="https://asdeporte.com/"
            >
              {{ $t("triatlon.return_asdeporte") }}
            </a>
          </div>
          </template>
        </div>
      </section>

      <section
        class="w-full md:w-3/5 mx-auto container-lg px-4"
        v-if="downloadCode != null"
      >
        <div class="text-lg font-bold p-4">{{ $t("success_payment.your_purchase") }}</div>
        <div class="flex bg-grey p-4 font-bold">
          <div class="w-5/12 md:w-2/5">{{ $t("success_payment.date_of_purchase") }}</div>
          <div class="w-4/12 md:w-2/5">{{ $t("success_payment.your_purchase") }}</div>
          <div class="w-3/12 md:w-1/5 text-center">{{ $t("success_payment.amount") }}</div>
        </div>
        <div class="w-full" v-for="(item, idx) in sale.Services" :key="idx">
          <template v-if="idx == 'Packages'">
            <!-- {{item}} -->
            <div class="flex p-4" v-for="(item2, idx2) in item" :key="idx2">
              <!-- {{item2}} -->
              <div class="w-5/12 md:w-2/5">
                {{ dateString(item2.SaleDate) }}
              </div>
              <div class="flex-col w-4/12 md:w-auto text-sm md:text-base">
                <div class="mb-2">
                  {{ item2.PackageDescription }}
                </div>
                <!-- <div class="mb-2">Fotos Xel-Há</div> -->
              </div>
              <div
                class="flex-col w-3/12 md:w-1/5 text-sm md:text-base text-right"
              >
                <div class="mb-2">
                  {{ item2.Amount | toCurrency }}
                  {{ sale.Currency }}
                </div>
                <!-- <div class="mb-2">$197.00 USD</div> -->
              </div>
            </div>
          </template>

          <template v-else>
            <!-- {{item}} -->
            <div class="flex p-4" v-for="(item2, idx2) in item" :key="idx2">
              <!-- {{item2}} -->
              <div class="w-5/12 md:w-2/5">
                {{ dateString(item2.SaleDate) }}
              </div>
              <div class="flex-col w-4/12 md:w-2/5 text-sm md:text-base">
                <div class="mb-2">{{ item2.ProductName }}</div>
                <!-- <div class="mb-2">Fotos Xel-Há</div> -->
              </div>
              <div
                class="flex-col w-3/12 md:w-1/5 text-sm md:text-base text-right"
              >
                <div class="mb-2">
                  {{ item2.Amount | toCurrency }}
                  {{ sale.Currency }}
                </div>
                <!-- <div class="mb-2">$197.00 USD</div> -->
              </div>
            </div>
          </template>
        </div>
        <div class="flex flex-auto border-y p-4 justify-end">
          <strong class="mr-2">Total:</strong>
          {{ sale.Amount | toCurrency }}
          {{ sale.Currency }}
        </div>
        <div class="flex py-4 px-4 items-center">
          <div class="flex-auto font-bold">{{ $t("success_payment.require_an_invoice") }}</div>
          <a
            href="https://www.xperienciasxcaret.mx/facturacion/?_ga=2.109010753.2116182801.1671813812-1339026656.1671222470"
            target="_blank"
            class="
              flex
              items-center
              rounded-full
              py-1
              px-4
              bg-white
              border border-black
              text-black
              cursor-pointer
            "
            >{{ $t("success_payment.request_your_invoice_here") }}</a
          >
        </div>
      </section>
    </template>
    <div class="active tabs-content" v-else>
      <img
        src="https://photo-public.s3.amazonaws.com/suf/no-data.png"
        alt=""
        class="no-data"
      />
      <center>
        <h3 class="text-2xl font-bold">¡Error!</h3>
        <h4 class="text-lg mb-8">
          {{ $t("messages.room_not_found") }}
        </h4>
      </center>

      <div
        class="
          w-full
          md:w-3/5
          mx-auto
          container-lg
          px-4
          md:px-0
          mt-10
          text-center
        "
      >
        <router-link
          class="
            backTo
            cursor-pointer
            bg-green-xcaret
            text-white
            rounded
            p-2
            pl-4
            pr-4
            cursor-pointer
          "
          :to="{
            name: 'albumes',
          }"
        >
          <span class="pointer-events-none">
            <span class="material-icons"> arrow_back </span>
            {{ $t("messages.my_albumes") }}
          </span>
        </router-link>
      </div>
    </div>

    <AddDownloadCode
      class="hidden"
      :code="downloadCode"
      v-if="downloadCode != null"
    ></AddDownloadCode>
  </div>
</template>

<script>
import CartMix from "../mixins/Cart";
import AlbumsMix from "../mixins/albums/GetAlbumsByEmail";
import recoverySale from "../logic/payment/RecoverySale";
import AddDownloadCode from "../forms/AddDownloadCode.vue";
import axios from 'axios';

export default {
  mixins: [CartMix, AlbumsMix],
  components: {
    AddDownloadCode,
  },
  data: () => ({
    sale: {},
    isEvent: null,
    downloadCode: null,
    hasProperty: false,
  }),
  methods: {
    getRouteAlbums() {
      const language = document.documentElement.lang;

      if (language == "es") {
        return "es.albumes";
      }

      return "albumes";
    },
    submitDownloadCode() {
      let btnDownloadCode = document.getElementById("formDownloadCode");
      btnDownloadCode.click();
    },
    async recoverySale() {
      try {
        const dsSalesId = this.$route.params.dsSalesId;
        const currency = this.$store.state.Currency;
        this.$store.dispatch("setLoading", true);
        const response = await this.$store.dispatch("RecoverySale", {
          dsSalesId,
          currency,
        });

        if (response.hasOwnProperty("ReservationNumber")) {
          this.hasProperty = true;

          this.sale = response;

          // mostramos el Codigo de descarga si la venta fue exitosa
          if (response?.Status?.Payment == "Approved") {
            this.downloadCode = this.flatten(this.sale, "DownloadCode").shift();
          }

          // reintentar mandar el código
          let trySend = false;
          if(this.downloadCode != "" || this.downloadCode != null) {
            let saleResponse = JSON.parse(sessionStorage.getItem('apiKoh'));
            if(saleResponse?.length) {
              saleResponse.forEach((el, i) => {
                if(el.downloadCode === "" || el.downloadCode === null) {
                  saleResponse[i].downloadCode = this.downloadCode;
                  trySend = true;
                }
              });
              //mandar a volver a insertar
              if(trySend)
                await this.$store.dispatch("SaleAdd", saleResponse);
              //Remove session req
              sessionStorage.removeItem('apiKoh');
            }
          }
        }
        this.$store.dispatch("setLoading", false);
      } catch (error) {
        this.$store.dispatch("setLoading", false);
        console.error(error);
      }
    },
  },
  created() {
    this.recoverySale();
    try {
      let eventDetails = this.$store.state.EventDetails;
      this.isEvent = Object.keys(eventDetails).length > 0 ? true : false;
    } catch {
      this.isEvent = false;
    }
  },
  mounted() {},
};
</script>
